var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 7688",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 10,
    viewBox: "0 0 24 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 713",
    style: {
      fill: "#f0f0f0",
      stroke: "#000",
      strokeWidth: ".5px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 10,
    rx: 2,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 9.5,
    rx: 1.75,
    style: {
      fill: "none"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20884",
    d: "M4 6.525V3h1.54a1.351 1.351 0 0 1 .86.243.811.811 0 0 1 .305.672.827.827 0 0 1-.145.49.831.831 0 0 1-.4.3.88.88 0 0 1 .467.3.842.842 0 0 1 .167.538.883.883 0 0 1-.317.728 1.364 1.364 0 0 1-.882.254zm.615-2.03h.815q.655 0 .655-.505t-.655-.5h-.815zm0 1.545h.9q.66 0 .66-.53t-.66-.53h-.9zm3.65.535q-.9 0-.9-1.01V4.08h.625v1.495a.59.59 0 0 0 .105.385.414.414 0 0 0 .335.125.534.534 0 0 0 .41-.173.646.646 0 0 0 .16-.458V4.08h.625v2.445h-.61V6.16a.812.812 0 0 1-.75.415zm3.13 0a.853.853 0 0 1-.97-.96V4.55h-.47v-.47h.47v-.73h.625v.73h.74v.47h-.74v1.03a.534.534 0 0 0 .105.36.43.43 0 0 0 .34.12.638.638 0 0 0 .145-.018l.155-.037.095.46a.839.839 0 0 1-.227.08 1.253 1.253 0 0 1-.268.03zm1.78 0a.853.853 0 0 1-.97-.96V4.55h-.47v-.47h.47v-.73h.625v.73h.74v.47h-.74v1.03a.534.534 0 0 0 .1.36.43.43 0 0 0 .34.12.638.638 0 0 0 .145-.018l.16-.037.1.46a.839.839 0 0 1-.228.08 1.253 1.253 0 0 1-.272.03zm1.89 0a1.342 1.342 0 0 1-.66-.15 1.08 1.08 0 0 1-.435-.443 1.407 1.407 0 0 1-.155-.678 1.392 1.392 0 0 1 .155-.675 1.084 1.084 0 0 1 .435-.44 1.342 1.342 0 0 1 .66-.155 1.342 1.342 0 0 1 .66.155 1.084 1.084 0 0 1 .435.44 1.392 1.392 0 0 1 .155.675 1.407 1.407 0 0 1-.155.678 1.08 1.08 0 0 1-.435.443 1.342 1.342 0 0 1-.66.15zm0-.475a.558.558 0 0 0 .45-.2.909.909 0 0 0 .17-.6.9.9 0 0 0-.17-.6.564.564 0 0 0-.45-.2.564.564 0 0 0-.45.2.9.9 0 0 0-.17.6.909.909 0 0 0 .17.6.558.558 0 0 0 .45.2zm1.765.425V4.08h.61v.38a.831.831 0 0 1 .337-.32 1.023 1.023 0 0 1 .477-.11q.865 0 .865 1.005v1.49h-.624v-1.46a.648.648 0 0 0-.108-.415.407.407 0 0 0-.332-.125.572.572 0 0 0-.44.168.64.64 0 0 0-.163.457v1.375z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonNewIcon);
export default __webpack_public_path__ + "static/media/ButtonNewIcon.993131548f4fbe8a4aba3c000f519f00.svg";
export { ForwardRef as ReactComponent };